<template>
  <div class="fp-list-item fp-list-item--big">
    <div class="fp-reviews">
      <div class="section-view-title section-view-title--with-link">
        <div class="section-view-title-content">
          Сады наших клиентов
          <div class="section-view-title-description">
            Делитесь фотографиями и получайте бонусы на будущие покупки
          </div>
        </div>
        <a href="/orders?tab=purchases-products" class="btn-main btn-big" @click="checkAuth">
          <span class="btn-main-overlay">
            <span class="btn-main-content">
              Оставить фотоотзыв
            </span>
          </span>
          <span class="btn-main-shadow"></span>
        </a>
      </div>
      <div class="fp-reviews-items" :class="{ 'fp-reviews-items--changing': isChanging }">
        <div class="fp-reviews-item" v-for="photo in visiblePhotos">
          <a :href="'/product/' + photo.pid + '?photo_id=' + photo.id" class="fp-item fp-item--2 fp-item--big">
            <div class="fp-item-picture" :style="'background-image: url(' + photo.image + ')'"></div>
            <div class="fp-item-content">
              <div class="fp-item-text">
                <div class="fp-item-text-content">
                  {{ photo.name }}, {{ photo.city }}
                </div>
              </div>
              <div class="fp-item-footer">
                <div class="fp-item-mark">
                  {{ photo.title }}
                </div>
                <div class="fp-item-comments">
                  <svg viewBox="0 0 84 78" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M49.5 77.375L39 64.25H19.5C18.5054 64.25 17.5516 63.8549 16.8483 63.1516C16.1451 62.4484 15.75 61.4946 15.75 60.5V19.6362C15.75 18.6417 16.1451 17.6879 16.8483 16.9846C17.5516 16.2813 18.5054 15.8862 19.5 15.8862H79.5C80.4945 15.8862 81.4484 16.2813 82.1516 16.9846C82.8549 17.6879 83.25 18.6417 83.25 19.6362V60.5C83.25 61.4946 82.8549 62.4484 82.1516 63.1516C81.4484 63.8549 80.4945 64.25 79.5 64.25H60L49.5 77.375ZM56.3962 56.75H75.75V23.3862H23.25V56.75H42.6037L49.5 65.3675L56.3962 56.75ZM4.5 0.5H68.25V8H8.25V49.25H0.75V4.25C0.75 3.25544 1.14509 2.30161 1.84835 1.59835C2.55161 0.895088 3.50544 0.5 4.5 0.5Z" />
                  </svg>
                  {{ photo.comments }}
                </div>
                <div class="fp-item-comments" v-if="photo.likes">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlink:href="#pp-heart-icon"></use>
                  </svg>
                  {{ photo.likes }}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      photos: [],
      visiblePhotos: [],
      timeout: null,
      maxIndex: 0,
      currentIndex: 0,
      isChanging: false
    }
  },
  methods: {
    getPhoto() {
      axios.get('/product-photos/front/get').then((response) => {
        this.applyPhoto(response.data.list)

        localStorage.setItem('frontpage-photos', JSON.stringify({
          lifetime: Date.now() + (60 * 60 * 1000),
          list: this.photos
        }))
      });
    },
    startTimer() {
      clearTimeout(this.timeout);
      this.isChanging = false;
      this.timeout = setTimeout(() => {
        if (this.currentIndex + 2 >= this.maxIndex) {
          this.nextSlide(0);
        }
        else {
          this.nextSlide(this.currentIndex + 2);
        }
      }, 5000);
    },
    nextSlide(index) {
      this.isChanging = true

      setTimeout(() => {
        this.currentIndex = index
        this.visiblePhotos = []
        for (let i = index; i < index + 2; i++) {
          if (this.photos[i]) {
            this.visiblePhotos.push(this.photos[i])
          }
        }
        this.startTimer();
      }, 600)
    },
    applyPhoto(photos) {
      this.photos = photos;
      this.maxIndex = this.photos.length;
      if (this.photos && this.maxIndex) {
        this.nextSlide(0);
        this.startTimer();
      }
    },
    checkAuth(e) {
      if (typeof drupalSettings !== 'object' || !drupalSettings.user || drupalSettings.user.uid == 0) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('authFormTrigger', {
          detail: {
            place: 'frontpage-photos',
            type: 'login',
          },
        }));
      }
    },
  },
  created() {
    const cachedJson = localStorage.getItem('frontpage-photos')
    if (cachedJson) {
      try {
        const cachedPhotos = JSON.parse(cachedJson)
        if (
          typeof cachedPhotos === 'object' &&
          'lifetime' in cachedPhotos &&
          Date.now() < cachedPhotos.lifetime
        ) {
          this.applyPhoto(cachedPhotos.list)
        }
        else {
          this.getPhoto()
        }
      }
      catch (error) {
        localStorage.setItem('frontpage-photos', null)
        this.getPhoto()
      }
    }
    else {
      this.getPhoto()
    }
  }
}
</script>